module.exports = __webpack_public_path__ + "assets/img/newsBg.2eca051c.png";